exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".marker[data-v-46661845]{background:#8280bf}.marker-number[data-v-46661845]{min-height:22px;border-top-left-radius:5px;border-top-right-radius:5px}.marker-answer[data-v-46661845]{min-height:22px;background:#f5f5f5;border-bottom-left-radius:5px;border-bottom-right-radius:5px}", ""]);

// exports
